module.exports = require('./lib/keyword_extractor');


/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/index.js
 ** module id = 2990
 ** module chunks = 0
 **/